/**
 * Tenant-scoped order and invoice serial formatting for cafe POS.
 * Format: ORD-000001, INV-000001 (6-digit zero-padded sequence).
 */

export const ORDER_PREFIX = 'ORD';
export const INVOICE_PREFIX = 'INV';
export const SERIAL_DIGIT_LENGTH = 6;

export function formatOrderId(sequence: number): string {
  if (!Number.isInteger(sequence) || sequence < 1) {
    throw new Error(`Invalid order sequence: ${sequence}`);
  }
  return `${ORDER_PREFIX}-${String(sequence).padStart(SERIAL_DIGIT_LENGTH, '0')}`;
}

export function formatInvoiceNumber(sequence: number): string {
  if (!Number.isInteger(sequence) || sequence < 1) {
    throw new Error(`Invalid invoice sequence: ${sequence}`);
  }
  return `${INVOICE_PREFIX}-${String(sequence).padStart(SERIAL_DIGIT_LENGTH, '0')}`;
}

/** Display order number on receipts and UI. */
export function resolveReceiptOrderNumber(order: { id?: string }): string {
  const id = order.id?.trim();
  if (!id) return 'N/A';
  if (/^ORD-\d{6}$/.test(id)) return id;
  return id.slice(-6).toUpperCase();
}

/**
 * Display bill/invoice number on receipts.
 * Prefers persisted invoiceNumber; falls back for legacy orders.
 */
export function resolveReceiptInvoiceNumber(order: {
  id?: string;
  invoiceNumber?: string;
}): string {
  const persisted = order.invoiceNumber?.trim();
  if (persisted) return persisted;

  const id = order.id?.trim();
  if (id) {
    return `CAF${id.slice(-5).toUpperCase()}`;
  }

  return `CAF${Date.now().toString().slice(-5)}`;
}
